'use client'

import { Tooltip } from '@dc-shared-web/components/base/Tooltip'
import { useEffect, useRef, useState } from 'react'

type TooltipProps = {
  content: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  sideOffset?: number
  withArrow?: boolean
  className?: string
  active?: boolean
}

export const EllipsisTooltip = ({
  content,
  side = 'bottom',
  sideOffset = 0,
  withArrow = false,
  className = 'tw-truncate tw-w-full',
}: TooltipProps) => {
  const textRef = useRef<HTMLSpanElement>(null)
  const [isOverflown, setIsOverflown] = useState(false)

  // displays tooltip if text is cut off and ellipsis is shown
  // setTimeout needed to wait for the text to be rendered on the page
  // checks for both horizontal overflow (truncate) and vertical overflow (line-clamp)
  useEffect(() => {
    setTimeout(() => {
      const text = textRef.current!
      if (!text) return

      const isHorizontallyOverflown = text.scrollWidth > text.clientWidth
      const isVerticallyOverflown = text.scrollHeight > text.clientHeight

      setIsOverflown(isHorizontallyOverflown || isVerticallyOverflown)
    }, 0)
  }, [content])

  return (
    <Tooltip
      side={side}
      sideOffset={sideOffset}
      active={isOverflown}
      content={content}
      withArrow={withArrow}
    >
      <span ref={textRef} className={className}>
        {content}
      </span>
    </Tooltip>
  )
}
